import { render, staticRenderFns } from "./AgroGenericModal.vue?vue&type=template&id=5df731d9&scoped=true&"
import script from "./AgroGenericModal.vue?vue&type=script&lang=ts&"
export * from "./AgroGenericModal.vue?vue&type=script&lang=ts&"
import style0 from "./agro-generic-modal.scss?vue&type=style&index=0&id=5df731d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df731d9",
  null
  
)

export default component.exports